export const STORAGE_TAB_SLUGS = {
  OVERVIEW: "overview",
  COC: "coc",
  STORED_DATA: "stored-data",
  PHOTOS: "photos",
  AUDIT: "audit",
} as const;

export type StorageTabSlug =
  typeof STORAGE_TAB_SLUGS[keyof typeof STORAGE_TAB_SLUGS];
